module.exports = __webpack_public_path__ + "MaterialIcons-Regular.012cf6a10129e2275d79.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/@covalent/core/common/styles/font/MaterialIcons-Regular.woff
// module id = ../../../../@covalent/core/common/styles/font/MaterialIcons-Regular.woff
// module chunks = 2